export const iconFontAwesomeMapsLocationPin = (
	<i className="fa-solid fa-location-pin"></i>
);
